import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { TestDriverBridge } from './test-driver-bridge';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AppConfigService } from './services/config/app-config.service';
import { ConsoleLogService } from './services/logging/logging.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatCardModule, NgxSkeletonLoaderModule],
  templateUrl: './app.component.html'
})
/**
 * Die `AppComponent`-Klasse dient als Hauptkomponente der Angular-Anwendung.
 * Sie ist für das Setup und die Verwaltung des Projektes zuständig.
 * BEGRÜNDUNG: Diese Klasse ist im Allgemeinen bei Angular-Projekten notwendig
 * und steht daher nicht mit den AFOs des TIM-Projekts in Verbindung. Sie bildet den Einstiegspunkt der
 * Software.
 */
export class AppComponent implements OnInit {
  title = 'tim-client-sachbearbeiter';
  protected readonly config: AppConfigService = inject(AppConfigService);
  private readonly testDriverBridge = inject(TestDriverBridge);
  private readonly consoleLogService = inject(ConsoleLogService);

  ngOnInit(): void {
    const isTesttreiber = this.config.get('isTesttreiberEnabled') === 'true';

    // Auf Testtreiber-Instanzen die Log-Unterdrückung NICHT anwenden: Diese Instanzen sind
    // Test-Infrastruktur, und ihre Konsolen-Logs (inkl. matrix-js-sdk/Rust-Crypto auf DEBUG)
    // sind die Diagnose-Grundlage. In echter Produktion (kein Testtreiber) weiterhin unterdrücken.
    if (!isTesttreiber) {
      this.consoleLogService.disableLogsInProd();
    }

    if (isTesttreiber) {
      this.testDriverBridge?.initializeServices();
    }
  }
}
